// =======================
// src/paginas/analise/gerarPortaria/portaria.js
// =======================
import React, { useState } from 'react';
import { Container, TextField, Typography, Button, Box, Paper, Grid } from '@mui/material';

const GeneratePortariaPage = () => {
  const [portariaData, setPortariaData] = useState({
    titulo: '',
    preambulo: '',
    artigos: '',
    data: '',
    local: '',
    assinatura: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPortariaData({
      ...portariaData,
      [name]: value
    });
  };

  const generatePortaria = () => {
    alert('Portaria gerada com sucesso!');
  };

  return (
    <Container maxWidth={false} disableGutters sx={{ mt: 5 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Gerar Portaria
      </Typography>

      <Box component="form" sx={{ mt: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Título da Portaria"
              name="titulo"
              value={portariaData.titulo}
              onChange={handleInputChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Preâmbulo"
              name="preambulo"
              value={portariaData.preambulo}
              onChange={handleInputChange}
              variant="outlined"
              multiline
              rows={4}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Artigos"
              name="artigos"
              value={portariaData.artigos}
              onChange={handleInputChange}
              variant="outlined"
              multiline
              rows={6}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Data"
              name="data"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={portariaData.data}
              onChange={handleInputChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Local"
              name="local"
              value={portariaData.local}
              onChange={handleInputChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Assinatura"
              name="assinatura"
              value={portariaData.assinatura}
              onChange={handleInputChange}
              variant="outlined"
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={generatePortaria}
        >
          Gerar Portaria
        </Button>
      </Box>

      {/* Pré-visualização Formatada */}
      <Box sx={{ mt: 5 }}>
        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="body1" align="center" fontWeight="bold">
            {portariaData.titulo || 'Título da Portaria'}
          </Typography>

          <Typography variant="body2" align="center" gutterBottom>
            {portariaData.local || 'Local'}, {portariaData.data || 'Data'}
          </Typography>

          <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
            <strong>Preâmbulo:</strong> {portariaData.preambulo || 'Insira o preâmbulo aqui.'}
          </Typography>

          <Typography variant="body2" gutterBottom>
            <strong>Artigos:</strong> {portariaData.artigos || 'Insira os artigos aqui.'}
          </Typography>

          <Typography variant="body2" align="right" sx={{ mt: 4 }}>
            <strong>{portariaData.assinatura || 'Assinatura'}</strong>
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default GeneratePortariaPage;
